import { Injectable } from '@angular/core';
import { HttpService } from '@core/services/http/http-api';
import { NEW_STOCKROOM_REQUEST, ORGANIZATION } from '@core/constants/api.constants';

@Injectable({
  providedIn: 'root',
})
export class NewStockroomRequestService {
  constructor(private httpService: HttpService) { }

  private getImContextHeaders(imContext?: { orgId?: string | number; stockroomId?: string | number }): any {
    return imContext
      ? { 'im-context': JSON.stringify(imContext) }
      : undefined;
  }

  getOrganizations(): Promise<any> {
    return this.httpService.get(NEW_STOCKROOM_REQUEST.GET_ORGS);
  }

  getStockrooms(orgId: string | number, imContext?: { orgId?: string | number; stockroomId?: string | number }): Promise<any> {
    return this.httpService.get(
      ORGANIZATION.GET_STOCKROOM_LIST(String(orgId)),
      undefined,
      this.getImContextHeaders(imContext)
    );
  }

  getStockroomDetails(stockroomId: string | number): Promise<any> {
    return this.httpService.get(ORGANIZATION.GET_ONE_STOCKROOM(String(stockroomId)));
  }

  validateStockroomName(
    orgId: string | number,
    stockroomName: string,
    imContext?: { orgId?: string | number; stockroomId?: string | number }
  ): Promise<any> {
    return this.httpService.get(
      NEW_STOCKROOM_REQUEST.VALIDATE_NAME(orgId, stockroomName),
      undefined,
      this.getImContextHeaders(imContext)
    );
  }

  getMasterStockrooms(
    orgId: string | number,
    imContext?: { orgId?: string | number; stockroomId?: string | number }
  ): Promise<any> {
    return this.httpService.get(
      NEW_STOCKROOM_REQUEST.GET_MASTER_STOCKROOMS(orgId),
      undefined,
      this.getImContextHeaders(imContext)
    );
  }

  submitNewStockroomRequest(payload: any): Promise<any> {
    return this.httpService.post(NEW_STOCKROOM_REQUEST.POST_NEW_STOCKROOM_REQUEST, payload);
  }
}
